/* eslint-disable no-nested-ternary */
import { Grid, IconButton, MenuItem } from '@material-ui/core';
import { Group, Visibility } from '@material-ui/icons';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import {
  getContractTypes,
  getStudentAffiliate,
  getStudentOnTeam,
  getTrainingById,
  setTeamMemberAction,
} from '@webapps/business';
import {
  Button,
  Modal,
  ModalSideBar,
  Pagination,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeadCell,
  TableHeadRow,
  TableRow,
  TextField,
  useMutation,
  useQuery,
  useRouter,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import AvatarStudent from 'components/Avatar/AvatarStudent';

import MessageBox from 'components/MessageBox';
import ModalConfirm from 'components/ModalConfirm/ModalConfirm';
import ProfilSidebar from 'components/ProfilSidebar';
import ProfilName from 'components/ProfilSidebar/Components/ProfilName';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import Team from 'components/Icons/Team';
import Information from 'components/Icons/Information';

const ExcluStudentBusiness = () => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { params } = useRouter();
  const { id: idParam } = params;
  const [page, setPage] = useState(1);
  const [keyword, setKeyword] = useState('');
  const [contractType, setContractType] = useState('');
  const [openMessageBox, setOpenMessageBox] = useState(false);
  const [candidatId, setCandidatId] = useState(0);

  const handleOpenMessageBox = () => {
    setOpenMessageBox(true);
  };
  const handleCloseMessageBox = () => {
    setOpenMessageBox(false);
  };

  const contactMember = (id) => {
    setCandidatId(id);
    handleOpenMessageBox();
  };

  const {
    // status: load,
    data: { content: infoMembers = [], totalElements } = {},
    refetch,
    // isFetching,
  } = useQuery(getStudentOnTeam, {
    key: ['teamsStudentsEXCLUDED', page + idParam + keyword + contractType],
    variables: {
      keyword,
      contractType,
      id: idParam,
      status: 'EXCLUDED',
      page: page - 1,
      size: 10,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const { data: contractTypes = [] } = useQuery(getContractTypes, {
    key: 'contractTypes',
  });

  const handlePaginationChange = (newPage) => {
    setPage(newPage);
  };

  const [viewProfil, setViewProfil] = useState(false);

  const [idSelect, setIdSelect] = useState(0);

  const handleOpenViewProfil = () => {
    setViewProfil(true);
  };
  const handleCloseViewProfil = () => {
    setViewProfil(false);
  };

  const viewCV = (id) => {
    setIdSelect(id);
    handleOpenViewProfil();
  };

  const searchKeyword = (e) => {
    setKeyword(e.target.value);
    setPage(1);
  };

  const searchContract = (e) => {
    if (e.target.value) {
      // eslint-disable-next-line no-unused-expressions
      e.target.value === 'all'
        ? setContractType('')
        : setContractType(e.target.value);
      setPage(1);
    }
  };

  const goToPreviousPage = () => {
    window.history.back();
  };

  const { addToast } = useToast();

  const {
    error: errorMemberTeamAction,
    isLoading: isLoadingMemberTeamAction,
    isSuccess: isSuccessMemberTeamAction,
    mutateAsync: mutateSetMemberTeam,
  } = useMutation(setTeamMemberAction);

  const deleteOnTeam = (id) => {
    mutateSetMemberTeam({
      id,
      action: 'exclude',
    });
  };

  useEffect(() => {
    if (errorMemberTeamAction) {
      addToast({
        status: 'error',
        message: 'Erreur',
      });
    }
    if (isSuccessMemberTeamAction) {
      addToast({
        status: 'success',
        message: 'Etudiant supprimé avec succès',
      });
      refetch();
      handleCloseViewConfirmDelete();
    }
  }, [isSuccessMemberTeamAction, errorMemberTeamAction]);

  const [selectedMember, setSelectedMember] = useState();

  const [viewConfirmDelete, setViewConfirmDelete] = useState(false);

  const handleOpenViewConfirmDelete = (id) => {
    setSelectedMember(id);
    setViewConfirmDelete(true);
  };

  const handleCloseViewConfirmDelete = () => {
    setViewConfirmDelete(false);
  };

  return (
    <div className={classes.container}>
      <Button
        className={classes.returnButton}
        onClick={goToPreviousPage}
        startIcon={<KeyboardBackspaceIcon />}
      >
        Revenir en arrière
      </Button>
      <Grid container spacing={3}>
        <Grid
          className={css({ background: 'white', margin: spacing(2) })}
          item
          xs={12}
        >
          <div style={{ marginBottom: spacing(3) }} className={global.title}>
            La liste des étudiants supprimés
          </div>
          {!infoMembers?.length ? (
            <div
              className={css({
                textAlign: 'center',
                marginTop: spacing(2),
                color: '#5D75A8',
              })}
            >
              <FormattedMessage id="noElements" />
            </div>
          ) : (
            <TableContainer>
              <Table className={classes.table}>
                <TableHead
                  className={css({ background: '#4289FB', color: 'white' })}
                >
                  <TableHeadRow>
                    <TableHeadCell align="left" className={classes.tableHead}>
                      Informations principales
                    </TableHeadCell>
                    <TableHeadCell align="center" className={classes.tableHead}>
                      Intitulé du poste
                    </TableHeadCell>
                    <TableHeadCell align="center" className={classes.tableHead}>
                      Contrat
                    </TableHeadCell>
                    <TableHeadCell align="center" className={classes.tableHead}>
                      Etat du contrat
                    </TableHeadCell>
                    <TableHeadCell align="center" className={classes.tableHead}>
                      Etablissement de formation
                    </TableHeadCell>
                  </TableHeadRow>
                </TableHead>
                <TableBody>
                  {infoMembers?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell align="left">
                        <div className={classes.infoCandidat}>
                          <div>
                            <AvatarStudent applicant={item?.student} />
                          </div>
                          <div
                            className={css({
                              marginLeft: spacing(1),
                              display: 'flex',
                              flexDirection: 'column',
                              justifyContent: 'center',
                              alignItems: 'flex-start',
                            })}
                          >
                            <div
                              className={css({
                                whiteSpace: 'nowrap',
                              })}
                            >
                              {item?.student?.lastname}{' '}
                              {item?.student?.firstname}
                            </div>
                            <div
                              className={css({
                                color: '#5D75A8',
                                whiteSpace: 'nowrap',
                              })}
                            >
                              {item?.student?.address?.cityCode}{' '}
                              {item?.student?.address?.city}
                            </div>
                          </div>
                        </div>
                      </TableCell>
                      <AffiliateInfo id={item?.student?.id} />
                      <TableCell align="center">
                        {item?.student?.classroom?.school?.name || 'Aucun'}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Grid>
      </Grid>
      <Pagination
        onChange={handlePaginationChange}
        page={page}
        pageCount={10}
        totalCount={totalElements}
      />
      <ModalSideBar
        handleClose={handleCloseViewProfil}
        open={viewProfil}
        title={<ProfilName userId={idSelect} />}
        width="700px"
      >
        <ProfilSidebar id={idSelect} typeOrganism="business" />
      </ModalSideBar>
      <Modal
        onCancel={handleCloseMessageBox}
        open={openMessageBox}
        // subTitle="Envoyez un message aux candidats et gardez contact dans votre
        // messagerie"
        title="Envoyer un message"
        withStep={false}
      >
        <div className={css({display: 'flex', flexDirection: 'row'})}>
          <span>
          <Information className={css({color:'#0060F9', height: 20, width: 20, marginRight: 10})}/>
          </span>
          <div className={css({fontSize: 14, color:'rgba(0, 0, 0, 0.87)'})}>
          Envoyez un message aux candidats et gardez contact dans votre
          messagerie
          </div>
        </div>
        <MessageBox id={candidatId} onCancel={handleCloseMessageBox} />
      </Modal>
      <ModalConfirm
        cancelBtnTitle="Non"
        confirmBtnTitle="Oui"
        confirmFunction={() => deleteOnTeam(selectedMember)}
        isLoading={isLoadingMemberTeamAction}
        onClose={handleCloseViewConfirmDelete}
        open={viewConfirmDelete}
        title="Supprimer de l'équipe"
      >
        Êtes-vous sûr de vouloir Supprimer l'étudiant de l'équipe
      </ModalConfirm>
    </div>
  );
};

const AffiliateInfo = ({ id }) => {
  const { css } = useStyles();
  const { data: { data: info = [] } = {} } = useQuery(getStudentAffiliate, {
    key: ['infoStudentBusinessAffiliate', id],
    variables: { id, type: 'business', status: 'enclosed' },
  });

  return info[0] ? (
    <>
      <TableCell align="center">{info[0]?.job?.label}</TableCell>
      <TableCell align="center">{info[0]?.contractType?.label}</TableCell>
      <TableCell align="center">
        {info[0]?.contract ? (
          info[0]?.contract?.status === 'SIGNED' ? (
            <span className={css({ color: 'green' })}>En cours</span>
          ) : (
            <span className={css({ color: '#FA8100' })}>En attente</span>
          )
        ) : (
          'Aucun reçu'
        )}
      </TableCell>
    </>
  ) : (
    <>
      <TableCell align="center">Aucun</TableCell>
      <TableCell align="center">Aucun</TableCell>
      <TableCell align="center">Aucun</TableCell>
    </>
  );
};

AffiliateInfo.propTypes = {
  id: PropTypes.string,
};

const Training = ({ id }) => {
  const { data: training = {} } = useQuery(getTrainingById, {
    key: ['training', id],
    variables: { id },
  });

  return <TableCell align="center">{training?.trainingType?.label}</TableCell>;
};

Training.propTypes = {
  id: PropTypes.string,
};

const styles = ({ spacing }) => ({
  container: {
    height: '100%',
    padding: spacing(5),
    minHeight: '100vh',
  },
  paper: {
    padding: spacing(2),
  },
  infoCandidat: { display: 'flex' },
  tableHead: {
    '&.MuiTableCell-head': {
      color: 'white',
      width: 350,
      maxWidth: '100%',
    },
  },
  containerSearch: {
    background: 'white',
    padding: spacing(2),
    paddingBottom: spacing(3),
    borderRadius: 10,

    marginTop: spacing(3),
  },
  searchContainer: {
    marginTop: spacing(2),

    display: 'flex',
    justifyContent: 'space-between',
  },
  button: {
    borderRadius: '400px',
  },
  modalsidebar: {
    width: '500px',
  },
  returnButton: {
    color: '#5A6DA1',
    '@media only screen and (max-width:1920px)': {fontSize: '13.500px'}, '@media only screen and (max-width:1600px)': {fontSize: '13.5000px'},
    border: '1px solid #C0D9FF',
    backgroundColor: 'white',
    borderRadius: '400px',
    width: '130px',
    fontWeight: 600,
    marginTop: spacing(2),
    
    
    
    
  },
});

export default ExcluStudentBusiness;
